function o(r) {
  const {
    date: t,
    format: a
  } = r;
  switch (a) {
    case "Jan 1, 2025":
      return t.toFormat("MMM d, yyyy");
    case "Wed, Jan 1":
      return t.toFormat("ccc, MMM d");
    case "Wed, Jan 1, 2025":
      return t.toFormat("ccc, MMM, d, yyyy");
    case "Wed, Jan 1 at 3:30 pm":
      return `${t.toFormat("ccc, MMM d")} at ${t.toFormat("h:mm a").toLowerCase()}`;
    default:
      throw new Error(`Unsupported format: ${a}`);
  }
}
export {
  o as formatDate
};
